import React from "react";
import "./createEvent.style.scss";

const CreateEvent = ({ key, eventTime, eventTitle}) => {

    return (
        <div className='event' key={key}>
            <div className="left">
                <div className="info">
                    <p>{eventTime}</p>
                </div>
                <div className="main">
                    <p>{eventTitle}</p>
                </div>
            </div>
        </div>
    );
};

export default CreateEvent;